import React, { useCallback, useContext } from 'react'
import { CellProps, Renderer } from 'react-table'
import makeStyles from '@mui/styles/makeStyles'
import CloseIcon from '@mui/icons-material/Close'
import { Trans } from 'react-i18next'
import { useSelector } from 'react-redux'
import { MarketState, TradeObject } from '@bdswiss/mt4-connector'
import { OpenPositionTableContext } from './OpenPositionTable'
import { getSymbolMarketStateSelector, marketOpenedForExistingPositionsSelector } from '../../../store/selectors'
import { RootState } from '../../../store/types'

const useStyles = makeStyles((theme) => ({
  icon: {
    fontSize: 14,
    margin: 4,
  },
  button: {
    display: 'flex',
    alignItems: 'center',
    border: 'none',
    backgroundColor: 'transparent',
    color: theme.palette.primary.main,
    cursor: 'pointer',
  },
  closeAllBtn: {
    display: 'flex',
    alignItems: 'center',
    border: 'none',
    backgroundColor: 'transparent',
    color: theme.palette.secondary.main,
    cursor: 'pointer',
  },
  disabledButton: {
    color: theme.palette.grey[500],
  },
}))

export const CloseActionCell: Renderer<CellProps<TradeObject, string>> = ({ row: { original } }) => {
  const classes = useStyles()
  const { dialogOpen } = useContext(OpenPositionTableContext)
  const marketOpened =
    useSelector((state: RootState) => getSymbolMarketStateSelector(state, original.symbol)) === MarketState.Open
  const handleClick = useCallback(
    (e) => {
      e.stopPropagation()
      dialogOpen(original)
    },
    [dialogOpen, original],
  )

  return (
    <>
      <button
        className={marketOpened ? classes.button : `${classes.button} ${classes.disabledButton}`}
        onClick={handleClick}
        disabled={!marketOpened}
      >
        <CloseIcon className={classes.icon} />
        <Trans i18nKey={'close'} />
      </button>
    </>
  )
}

export const CloseAllHeader: Renderer<CellProps<TradeObject, string>> = () => {
  const classes = useStyles()
  const { dialogOpenAll } = useContext(OpenPositionTableContext)
  const marketOpened = useSelector(marketOpenedForExistingPositionsSelector)

  return (
    <button
      className={marketOpened ? classes.closeAllBtn : `${classes.closeAllBtn} ${classes.disabledButton}`}
      onClick={dialogOpenAll}
      data-guided-tour="closeAllBtn"
      disabled={!marketOpened}
    >
      <CloseIcon className={classes.icon} />
      <Trans i18nKey={'closeAll'} />
    </button>
  )
}
